import React, { useState } from "react";
import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import classNames from "classnames";
import { Plus, ChevronDown } from "react-feather";

export function TeamSidebarDropdown({ closeMobileNavigation }) {
  let teams = usePage().props.global_teams;
  let { url } = usePage();

  const [isOpen, setIsOpen] = useState(url.startsWith("/teams"));

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="group mb-2 flex">
        <InertiaLink
          className={classNames(
            "mr-1 flex-1 rounded-sm px-4 py-3 text-[18px] font-bold leading-[130%]",
            {
              "lg:group-hover:bg-black-dark": !url.startsWith("/teams"),
              "bg-yellow text-black group-hover:bg-yellow lg:group-hover:bg-yellow":
                url.startsWith("/teams"),
            },
          )}
          href="/teams"
          onClick={closeMobileNavigation}
        >
          Teams
        </InertiaLink>

        <span
          className={classNames(
            "cursor-pointer rounded-sm p-3 lg:group-hover:bg-black",
            {
              "lg:group-hover:bg-black-dark": !url.startsWith("/teams"),
              "bg-yellow text-black group-hover:bg-yellow lg:group-hover:bg-yellow":
                url.startsWith("/teams"),
            },
          )}
          onClick={handleToggleDropdown}
        >
          <ChevronDown
            className={`transition-all ${isOpen ? "rotate-180" : ""}`}
          />
        </span>
      </div>

      {isOpen && teams !== undefined && teams !== null && (
        <>
          {teams.data
            .filter((t) => !t.is_deleted)
            .filter((t) => t.is_favorite)
            .map((team) => (
              <InertiaLink
                key={team.id}
                className={classNames(
                  "rounded-sm px-4 py-2 text-base leading-[137%]",
                  {
                    "hover:bg-black-dark": !url.startsWith(`/teams/${team.id}`),
                    "bg-yellow text-black hover:bg-yellow group-hover:bg-yellow":
                      url.startsWith(`/teams/${team.id}`),
                  },
                )}
                href={`/teams/${team.id}`}
                onClick={closeMobileNavigation}
              >
                {team.name}
              </InertiaLink>
            ))}
        </>
      )}

      {isOpen && (
        <InertiaLink
          className={classNames(
            "relative rounded-sm px-4 py-2 text-base leading-[137%]",
            {
              "hover:bg-black-dark": !url.startsWith(`/teams/new`),
              "bg-yellow text-black hover:bg-yellow group-hover:bg-yellow":
                url.startsWith(`/teams/new`),
            },
          )}
          href={route("team.create")}
          onClick={closeMobileNavigation}
        >
          Create new team
          <Plus className="absolute right-2 top-1/2 -translate-y-1/2" />
        </InertiaLink>
      )}

      {isOpen && <span className="border-b border-[#535E63] px-4 py-1"></span>}
    </>
  );
}
